import {
  FETCH_SMM_POST_CHANNEL_STATUS_LIST,
  FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS,
  FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE,
  CREATE_SMM_POST_CHANNEL_STATUS,
  CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  CREATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  UPDATE_SMM_POST_CHANNEL_STATUS,
  UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  DELETE_SMM_POST_CHANNEL_STATUS,
  DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  DELETE_SMM_POST_CHANNEL_STATUS_FAILURE,
  FETCH_SMM_POST_LIST,
  FETCH_SMM_POST_LIST_SUCCESS,
  FETCH_SMM_POST_LIST_FAILURE,
  FETCH_SMM_POST_DATA,
  FETCH_SMM_POST_DATA_SUCCESS,
  FETCH_SMM_POST_DATA_FAILURE,
  CREATE_SMM_POST,
  CREATE_SMM_POST_SUCCESS,
  CREATE_SMM_POST_FAILURE,
  UPDATE_SMM_POST,
  UPDATE_SMM_POST_SUCCESS,
  UPDATE_SMM_POST_FAILURE,
  DELETE_SMM_POST,
  DELETE_SMM_POST_SUCCESS,
  DELETE_SMM_POST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  GENERATE_SMM_POST_CONTENT,
  GENERATE_SMM_POST_CONTENT_SUCCESS,
  GENERATE_SMM_POST_CONTENT_FAILURE,
  GENERATE_SMM_POST_IMAGE,
  GENERATE_SMM_POST_IMAGE_SUCCESS,
  GENERATE_SMM_POST_IMAGE_FAILURE,
  SOCIAL_MEDIA_CONNECT_START,
  SOCIAL_MEDIA_CONNECT_START_SUCCESS,
  SOCIAL_MEDIA_CONNECT_START_FAILURE,
  SOCIAL_MEDIA_CONNECT_COMPLETE,
  SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS,
  SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE,
  SOCIAL_MEDIA_CONNECT_ASSIGN,
  SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS,
  SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE,
  SOCIAL_MEDIA_CONNECT_DISCONNECT,
  SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS,
  SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE,
} from "./actionType";

// Action Creators
//FETCH_SMM_POST_CHANNEL_STATUS_LIST
export const fetchSmmPostChannelStatusList = (params) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_LIST,
  payload: params,
});

export const fetchSmmPostChannelStatusListSuccess = (data) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS,
  payload: data,
});

export const fetchSmmPostChannelStatusListFailure = (error) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE,
  payload: error,
});

//FETCH_SMM_POST_CHANNEL_STATUS_DATA
export const fetchSmmPostChannelStatusData = (id) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_DATA,
  payload: id,
});

export const fetchSmmPostChannelStatusDataSuccess = (data) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS,
  payload: data,
});

export const fetchSmmPostChannelStatusDataFailure = (error) => ({
  type: FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE,
  payload: error,
});

//CREATE_SMM_POST_CHANNEL_STATUS
export const createSmmPostChannelStatus = (data) => ({
  type: CREATE_SMM_POST_CHANNEL_STATUS,
  payload: data,
});

export const createSmmPostChannelStatusSuccess = (data) => ({
  type: CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  payload: data,
});

export const createSmmPostChannelStatusFailure = (error) => ({
  type: CREATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  payload: error,
});

//UPDATE_SMM_POST_CHANNEL_STATUS
export const updateSmmPostChannelStatus = (data) => ({
  type: UPDATE_SMM_POST_CHANNEL_STATUS,
  payload: data,
});

export const updateSmmPostChannelStatusSuccess = (data) => ({
  type: UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  payload: data,
});

export const updateSmmPostChannelStatusFailure = (error) => ({
  type: UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE,
  payload: error,
});

//DELETE_SMM_POST_CHANNEL_STATUS
export const deleteSmmPostChannelStatus = (id) => ({
  type: DELETE_SMM_POST_CHANNEL_STATUS,
  payload: id,
});

export const deleteSmmPostChannelStatusSuccess = (data) => ({
  type: DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS,
  payload: data,
});

export const deleteSmmPostChannelStatusFailure = (error) => ({
  type: DELETE_SMM_POST_CHANNEL_STATUS_FAILURE,
  payload: error,
});

//FETCH_SMM_POST_LIST
export const fetchSmmPostList = () => ({
  type: FETCH_SMM_POST_LIST,
});

export const fetchSmmPostListSuccess = (data) => ({
  type: FETCH_SMM_POST_LIST_SUCCESS,
  payload: data,
});

export const fetchSmmPostListFailure = (error) => ({
  type: FETCH_SMM_POST_LIST_FAILURE,
  payload: error,
});

//FETCH_SMM_POST_DATA
export const fetchSmmPostData = (id) => ({
  type: FETCH_SMM_POST_DATA,
  payload: id,
});

export const fetchSmmPostDataSuccess = (data) => ({
  type: FETCH_SMM_POST_DATA_SUCCESS,
  payload: data,
});

export const fetchSmmPostDataFailure = (error) => ({
  type: FETCH_SMM_POST_DATA_FAILURE,
  payload: error,
});

//CREATE_SMM_POST
export const createSmmPost = (data) => ({
  type: CREATE_SMM_POST,
  payload: data,
});

export const createSmmPostSuccess = (data) => ({
  type: CREATE_SMM_POST_SUCCESS,
  payload: data,
});

export const createSmmPostFailure = (error) => ({
  type: CREATE_SMM_POST_FAILURE,
  payload: error,
});

//UPDATE_SMM_POST
export const updateSmmPost = (data) => ({
  type: UPDATE_SMM_POST,
  payload: data,
});

export const updateSmmPostSuccess = (data) => ({
  type: UPDATE_SMM_POST_SUCCESS,
  payload: data,
});

export const updateSmmPostFailure = (error) => ({
  type: UPDATE_SMM_POST_FAILURE,
  payload: error,
});

//DELETE_SMM_POST
export const deleteSmmPost = (id) => ({
  type: DELETE_SMM_POST,
  payload: id,
});

export const deleteSmmPostSuccess = (data) => ({
  type: DELETE_SMM_POST_SUCCESS,
  payload: data,
});

export const deleteSmmPostFailure = (error) => ({
  type: DELETE_SMM_POST_FAILURE,
  payload: error,
});

//FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST
// Task 24873 - social channel connection
export const socialMediaConnectStart = (profileId) => ({
  type: SOCIAL_MEDIA_CONNECT_START,
  payload: profileId,
});
export const socialMediaConnectStartSuccess = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_START_SUCCESS,
  payload: data,
});
export const socialMediaConnectStartFailure = (error) => ({
  type: SOCIAL_MEDIA_CONNECT_START_FAILURE,
  payload: error,
});

export const socialMediaConnectComplete = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_COMPLETE,
  payload: data,
});
export const socialMediaConnectCompleteSuccess = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS,
  payload: data,
});
export const socialMediaConnectCompleteFailure = (error) => ({
  type: SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE,
  payload: error,
});

export const socialMediaConnectAssign = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_ASSIGN,
  payload: data,
});
export const socialMediaConnectAssignSuccess = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS,
  payload: data,
});
export const socialMediaConnectAssignFailure = (error) => ({
  type: SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE,
  payload: error,
});

export const socialMediaConnectDisconnect = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_DISCONNECT,
  payload: data,
});
export const socialMediaConnectDisconnectSuccess = (data) => ({
  type: SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS,
  payload: data,
});
export const socialMediaConnectDisconnectFailure = (error) => ({
  type: SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE,
  payload: error,
});

export const fetchMasterSocialMediaProviderList = () => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST,
});

export const fetchMasterSocialMediaProviderListSuccess = (data) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS,
  payload: data,
});

export const fetchMasterSocialMediaProviderListFailure = (error) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE,
  payload: error,
});

//FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA
export const fetchMasterSocialMediaProviderData = (id) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA,
  payload: id,
});

export const fetchMasterSocialMediaProviderDataSuccess = (data) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS,
  payload: data,
});

export const fetchMasterSocialMediaProviderDataFailure = (error) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE,
  payload: error,
});

//CREATE_MASTER_SOCIAL_MEDIA_PROVIDER
export const createMasterSocialMediaProvider = (data) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  payload: data,
});

export const createMasterSocialMediaProviderSuccess = (data) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  payload: data,
});

export const createMasterSocialMediaProviderFailure = (error) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  payload: error,
});

//UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER
export const updateMasterSocialMediaProvider = (data) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  payload: data,
});

export const updateMasterSocialMediaProviderSuccess = (data) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  payload: data,
});

export const updateMasterSocialMediaProviderFailure = (error) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  payload: error,
});

//DELETE_MASTER_SOCIAL_MEDIA_PROVIDER
export const deleteMasterSocialMediaProvider = (id) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROVIDER,
  payload: id,
});

export const deleteMasterSocialMediaProviderSuccess = (data) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS,
  payload: data,
});

export const deleteMasterSocialMediaProviderFailure = (error) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE,
  payload: error,
});

//FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST
export const fetchMasterSocialMediaProfileList = () => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST,
});

export const fetchMasterSocialMediaProfileListSuccess = (data) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS,
  payload: data,
});

export const fetchMasterSocialMediaProfileListFailure = (error) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE,
  payload: error,
});

//FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA
export const fetchMasterSocialMediaProfileData = (id) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA,
  payload: id,
});

export const fetchMasterSocialMediaProfileDataSuccess = (data) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS,
  payload: data,
});

export const fetchMasterSocialMediaProfileDataFailure = (error) => ({
  type: FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE,
  payload: error,
});

//CREATE_MASTER_SOCIAL_MEDIA_PROFILE
export const createMasterSocialMediaProfile = (data) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROFILE,
  payload: data,
});

export const createMasterSocialMediaProfileSuccess = (data) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  payload: data,
});

export const createMasterSocialMediaProfileFailure = (error) => ({
  type: CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  payload: error,
});

//UPDATE_MASTER_SOCIAL_MEDIA_PROFILE
export const updateMasterSocialMediaProfile = (data) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROFILE,
  payload: data,
});

export const updateMasterSocialMediaProfileSuccess = (data) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  payload: data,
});

export const updateMasterSocialMediaProfileFailure = (error) => ({
  type: UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  payload: error,
});

//DELETE_MASTER_SOCIAL_MEDIA_PROFILE
export const deleteMasterSocialMediaProfile = (id) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROFILE,
  payload: id,
});

export const deleteMasterSocialMediaProfileSuccess = (data) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS,
  payload: data,
});

export const deleteMasterSocialMediaProfileFailure = (error) => ({
  type: DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE,
  payload: error,
});

//GENERATE_SMM_POST_CONTENT
export const generateSmmPostContent = (data) => ({
  type: GENERATE_SMM_POST_CONTENT,
  payload: data,
});

export const generateSmmPostContentSuccess = (data) => ({
  type: GENERATE_SMM_POST_CONTENT_SUCCESS,
  payload: data,
});

export const generateSmmPostContentFailure = (error) => ({
  type: GENERATE_SMM_POST_CONTENT_FAILURE,
  payload: error,
});

//GENERATE_SMM_POST_IMAGE
export const generateSmmPostImage = (data) => ({
  type: GENERATE_SMM_POST_IMAGE,
  payload: data,
});

export const generateSmmPostImageSuccess = (data) => ({
  type: GENERATE_SMM_POST_IMAGE_SUCCESS,
  payload: data,
});

export const generateSmmPostImageFailure = (error) => ({
  type: GENERATE_SMM_POST_IMAGE_FAILURE,
  payload: error,
});
